package one.primehealth.app

enum class Flavour {
    Stage,
    Prod,
}